import React, { useState } from 'react';
// ✅ Axios ki jagah aapka custom instance import kiya
import axiosInstance from "../utils/axiosInstance"; 

const FirebaseConfig = () => {
    const [jsonInput, setJsonInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    const handleSaveConfig = async () => {
        // --- Console Log 1: Start ---
        console.log("🚀 Debug: handleSaveConfig function triggered");

        if (!jsonInput.trim()) {
            console.warn("⚠️ Debug: Textarea is empty");
            setMessage({ type: "error", text: "Please paste the JSON content first!" });
            return;
        }

        setLoading(true);
        setMessage({ type: "", text: "" });

        try {
            // --- Console Log 2: Raw Input ---
            console.log("📝 Debug: Raw input received:", jsonInput);

            // 1. Check karein ki JSON valid hai ya nahi
            const parsedData = JSON.parse(jsonInput);
            
            // --- Console Log 3: Parsed Data ---
            console.log("✅ Debug: JSON successfully parsed:", parsedData);

            // 2. API Call (Ab axiosInstance use ho raha hai)
            const requestUrl = '/api/chat/settings/save-firebase-config'; 
            const payload = { configData: parsedData };

            // --- Console Log 4: Request Details ---
            // Note: axiosInstance ka Base URL console mein nahi dikhega, 
            // par Network tab mein aap pura URL dekh sakte hain.
            console.log(`📡 Debug: Attempting POST request via axiosInstance to: ${requestUrl}`);
            console.log("📦 Debug: Request Payload:", payload);

            // ✅ axios ki jagah axiosInstance use kiya
            const response = await axiosInstance.post(requestUrl, payload);

            // --- Console Log 5: Success Response ---
            console.log("🎉 Debug: API Response Success:", response.data);

            if (response.data.success) {
                setMessage({ type: "success", text: "🔥 Firebase Config updated successfully!" });
                setJsonInput(""); // Clear field after success
            }
        } catch (error) {
            // --- Console Log 6: Detailed Error ---
            console.error("❌ Debug: Config Error Detected!");
            
            if (error.response) {
                // Server ne response diya lekin status 2xx nahi hai (Jaise 404, 500)
                console.error("📡 Error Status:", error.response.status);
                console.error("📄 Error Data from Server:", error.response.data);
                console.error("🔗 Requested URL was:", error.config.url);
            } else if (error.request) {
                // Request bheji gayi par koi response nahi mila
                console.error("⏳ Error: No response received from server. Check if Backend is running on Port 5002.");
            } else {
                // Request setup karte waqt error aaya
                console.error("⚙️ Error Message:", error.message);
            }

            const errorMsg = error.response?.data?.message || "Invalid JSON format or Server unreachable.";
            setMessage({ type: "error", text: errorMsg });
        } finally {
            // --- Console Log 7: End ---
            console.log("🏁 Debug: handleSaveConfig process finished.");
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>Push Notification Settings</h2>
                <p style={styles.subtitle}>
                    Paste the entire content of your <b>serviceAccountKey.json</b> file below. 
                    This will enable real-time notifications for your users.
                </p>

                <textarea
                    style={styles.textarea}
                    placeholder='{ "type": "service_account", "project_id": "..." }'
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    spellCheck="false"
                />

                {message.text && (
                    <div style={{
                        ...styles.alert,
                        backgroundColor: message.type === "success" ? "#dcfce7" : "#fee2e2",
                        color: message.type === "success" ? "#166534" : "#991b1b"
                    }}>
                        {message.text}
                    </div>
                )}

                <button
                    onClick={handleSaveConfig}
                    disabled={loading}
                    style={{
                        ...styles.button,
                        backgroundColor: loading ? "#9ca3af" : "#008069"
                    }}
                >
                    {loading ? "Saving..." : "Update Configuration"}
                </button>

                <div style={styles.footer}>
                    ⚠️ Note: Only Admin can update this. Make sure the JSON includes <i>private_key</i>.
                </div>
            </div>
        </div>
    );
};

// Simple CSS-in-JS logic (remains same)
const styles = {
    container: { padding: '20px', display: 'flex', justifyContent: 'center' },
    card: { 
        backgroundColor: '#fff', 
        padding: '24px', 
        borderRadius: '12px', 
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)', 
        maxWidth: '700px', 
        width: '100%' 
    },
    title: { fontSize: '22px', fontWeight: 'bold', color: '#333', marginBottom: '8px' },
    subtitle: { fontSize: '14px', color: '#666', marginBottom: '16px', lineHeight: '1.5' },
    textarea: { 
        width: '100%', 
        height: '250px', 
        fontFamily: 'monospace', 
        fontSize: '13px', 
        padding: '12px', 
        borderRadius: '8px', 
        border: '1px solid #ddd', 
        backgroundColor: '#f8fafc',
        resize: 'vertical',
        outline: 'none'
    },
    button: {
        marginTop: '16px',
        width: '100%',
        padding: '12px',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: '0.3s'
    },
    alert: { padding: '12px', borderRadius: '6px', marginTop: '16px', fontSize: '14px' },
    footer: { marginTop: '16px', fontSize: '11px', color: '#999', textAlign: 'center' }
};

export default FirebaseConfig;